/**
 * TimelineSearchBar Component
 *
 * Search input for filtering timeline events by text.
 *
 * @module components/timeline/TimelineSearchBar
 */

import React, { useState, useEffect } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';

/**
 * TimelineSearchBar component
 * @param {Object} props
 * @param {string} props.value - Current search value
 * @param {Function} props.onChange - Callback when search value changes
 * @param {string} props.placeholder - Placeholder text
 */
const TimelineSearchBar = ({
  value = '',
  onChange,
  placeholder = 'Buscar en la bitacora...',
}) => {
  const [localValue, setLocalValue] = useState(value);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(localValue);
    }, 300);

    return () => clearTimeout(timer);
  }, [localValue, onChange]);

  // Sync with external value changes
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleClear = () => {
    setLocalValue('');
    onChange('');
  };

  return (
    <div className="timeline-search mb-3">
      <InputGroup>
        <InputGroup.Text className="bg-white">
          <i className="bi bi-search text-muted"></i>
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder={placeholder}
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
          className="border-start-0"
        />
        {localValue && (
          <Button
            variant="outline-secondary"
            onClick={handleClear}
            title="Limpiar busqueda"
          >
            <i className="bi bi-x-lg"></i>
          </Button>
        )}
      </InputGroup>
    </div>
  );
};

export default TimelineSearchBar;
